import VueBaseController from '../vue_base'

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/wl_configuration/new.vue') }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/wl_configuration/show.vue') }

  static values = {
    wlConfiguration: Object,
    wlCname: String
  }

  connect() {
    super.connect({
      wlConfigurationRaw: this.wlConfigurationValue,
      cnameValue: this.wlCnameValue
    })
  }
}
